import React, { useState } from "react";
import { X, Upload, Link2 } from "lucide-react";
import { FORMATS } from "./contentUtils";
import { MediaPreview } from "./StatusBadge";

const cls = "w-full rounded-2xl border border-line bg-white px-4 py-2.5 text-sm text-ink outline-none transition-colors focus:border-bordeaux";

export function ImageUpload({ value, onChange, upload, testid }) {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    const url = await upload(f);
    setBusy(false);
    if (url) onChange(url);
  };
  return (
    <div className="flex items-center gap-3">
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-line bg-white px-4 py-2 text-xs font-medium text-ink-soft transition-colors hover:border-bordeaux hover:text-bordeaux">
        <Upload size={14} /> {busy ? "Envoi…" : value ? "Changer la photo" : "Ajouter une photo (optionnel)"}
        <input data-testid={testid} type="file" accept="image/*" className="hidden" onChange={pick} />
      </label>
      {value && <button onClick={() => onChange("")} className="text-xs text-ink-muted hover:text-bordeaux">Retirer</button>}
    </div>
  );
}

export default function MediaForm({ title, onSubmit, onClose, upload }) {
  const [f, setF] = useState({ url: "", image: "", title: "", format: "Réel", hook: "", cta: "", note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    setBusy(true);
    const ok = await onSubmit(f);
    setBusy(false);
    if (ok) onClose();
  };
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-ink/40 p-4 py-10 backdrop-blur-[2px]" onClick={onClose}>
      <div data-testid="media-form" onClick={(e) => e.stopPropagation()} className="grid w-full max-w-3xl gap-6 rounded-[28px] bg-cream p-6 shadow-2xl sm:grid-cols-[200px_1fr] sm:p-8">
        <div className="mx-auto aspect-[4/5] w-full max-w-[200px] overflow-hidden rounded-2xl border border-line bg-white"><MediaPreview url={f.url} image={f.image} /></div>
        <div className="space-y-3">
          <div className="flex items-center justify-between"><h3 className="font-sans text-xl font-medium text-ink">{title}</h3><button onClick={onClose} className="rounded-full p-1.5 text-ink-muted hover:bg-bordeaux-tint hover:text-bordeaux"><X size={18} /></button></div>
          <div className="relative"><Link2 size={15} className="absolute left-4 top-3 text-ink-muted" /><input data-testid="media-url" value={f.url} onChange={set("url")} placeholder="Lien du contenu (Instagram…)" className={cls + " pl-10"} /></div>
          <ImageUpload value={f.image} onChange={(image) => setF({ ...f, image })} upload={upload} testid="media-image" />
          <input data-testid="media-title" value={f.title} onChange={set("title")} placeholder="Titre (optionnel)" className={cls} />
          <select data-testid="media-format" value={f.format} onChange={set("format")} className={cls}>{FORMATS.map((x) => <option key={x}>{x}</option>)}</select>
          <textarea data-testid="media-hook" rows={2} value={f.hook} onChange={set("hook")} placeholder="L'accroche" className={cls} />
          <textarea data-testid="media-cta" rows={2} value={f.cta} onChange={set("cta")} placeholder="Le CTA" className={cls} />
          <textarea data-testid="media-note" rows={2} value={f.note} onChange={set("note")} placeholder="Pourquoi ce contenu, ce qu'il faut retenir…" className={cls} />
          <div className="flex justify-end"><button data-testid="media-submit" onClick={submit} disabled={busy || !(f.url || f.image || f.title)} className="rounded-full bg-bordeaux px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-bordeaux-dark disabled:opacity-40">{busy ? "Envoi…" : "Enregistrer"}</button></div>
        </div>
      </div>
    </div>
  );
}
